export default {
  menuItem: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
    "&.Mui-selected": {
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      },
    },
    "&.Mui-selected:before": {
      display: "inline-block",
      content: "''",
      width: 0,
      height: 0,
      borderLeft: "7px solid black",
      borderRight: "7px solid transparent",
      borderBottom: "7px solid transparent",
      borderTop: "7px solid transparent",
      marginRight: 5,
    },
  },
};
